import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-project-date',
  templateUrl: './project-date.component.html',
  styleUrls: ['./project-date.component.scss']
})
export class ProjectDateComponent implements OnInit {
  recommendation: any ;
  currentStatus: string = ''
  recommendationStatus : any;
  projectForm: FormGroup;
  isLoading: boolean = false;
  email: string = '';
  siteId: string = '';
  @Output() onSuccess = new EventEmitter<any>();

  constructor(private fb: FormBuilder, private modalService: NgbModal,
    public userService: UserService
  ) { 
    this.projectForm = this.fb.group({
      startDate: [null, Validators.required],
      endDate: [null, Validators.required],
    });
  }

  ngOnInit(): void {
  }

  close(data = null): void {
    this.onSuccess.emit(data);
    this.modalService.dismissAll(data);
  }

  saveChanges(): void {
    if(this.projectForm.invalid || !this.recommendation) {
      return;
    }
    const recommendationStatus:any = {};
    recommendationStatus[`${this.recommendation.category}_startDate`] = this.projectForm.value.startDate;
    recommendationStatus[`${this.recommendation.category}_endDate`] = this.projectForm.value.endDate;
    this.userService.updateInterest(this.recommendation, this.currentStatus, recommendationStatus, this.siteId, this.email).subscribe((response) => {
      if(response) {
        this.close(response)
      }
    })
  }

}
